import { render, staticRenderFns } from "./CashboxSelect.vue?vue&type=template&id=208d2334&scoped=true&"
import script from "./CashboxSelect.vue?vue&type=script&lang=js&"
export * from "./CashboxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d2334",
  null
  
)

export default component.exports